// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__Ov1gM","description":"PatientConsentPreview_description__2njHQ"};